import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IntlProvider, addLocaleData } from 'react-intl';
import { hasLocaleData } from 'react-intl/src/locale-data-registry';
var propTypes = {
  /* eslint-disable react/no-unused-prop-types */
  locale: PropTypes.string,
  messages: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.string), PropTypes.objectOf(PropTypes.objectOf(PropTypes.string))]),
  getLocale: PropTypes.func,
  getMessages: PropTypes.func,

  /* eslint-enable react/no-unused-prop-types */
  children: PropTypes.node
};
var defaultProps = {
  locale: 'en',
  messages: {},
  getLocale: null,
  getMessages: null,
  children: null
};

var IntlContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(IntlContainer, _Component);

  function IntlContainer(props) {
    var _this;

    _classCallCheck(this, IntlContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IntlContainer).call(this, props));
    _this.state = {
      locales: {} // eslint-disable-line react/no-unused-state

    };
    return _this;
  }

  _createClass(IntlContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var locale = this.getLocale();
      this.loadLocaleData(locale);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevLocale = this.getLocale(prevProps);
      var locale = this.getLocale();
      var localeChanged = prevLocale !== locale;

      if (localeChanged) {
        this.loadLocaleData(locale);
      }
    }
  }, {
    key: "getLocale",
    value: function getLocale(props) {
      var _ref = props || this.props,
          getLocale = _ref.getLocale,
          locale = _ref.locale;

      return getLocale !== null ? getLocale() : locale;
    }
  }, {
    key: "getMessages",
    value: function getMessages(props) {
      var _ref2 = props || this.props,
          getMessages = _ref2.getMessages,
          messages = _ref2.messages;

      var locale = this.getLocale(props);
      return getMessages !== null ? getMessages(locale) : messages[locale] || messages;
    }
  }, {
    key: "loadLocaleData",
    value: function loadLocaleData(locale) {
      var _this2 = this;

      if (hasLocaleData(locale)) {
        return;
      }

      import("react-intl/locale-data/".concat(locale)).then(function (_ref3) {
        var localeData = _ref3["default"];
        addLocaleData(localeData);

        _this2.setState(function (state) {
          return {
            locales: _objectSpread({}, state.locales, _defineProperty({}, locale, localeData))
          };
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          getLocale = _this$props.getLocale,
          getMessages = _this$props.getMessages,
          props = _objectWithoutProperties(_this$props, ["children", "getLocale", "getMessages"]);

      var locale = this.getLocale();

      if (!hasLocaleData(locale)) {
        return null;
      }

      return React.createElement(IntlProvider, _extends({}, props, {
        locale: locale,
        messages: this.getMessages()
      }), children);
    }
  }]);

  return IntlContainer;
}(Component);

IntlContainer.propTypes = propTypes;
IntlContainer.defaultProps = defaultProps;
export default IntlContainer;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/react-container/es/IntlContainer.js
// module id = null
// module chunks = 